<script lang="ts">
	import type { OperationModel } from '@app/models/api/OperationModel';
	import { ButtonBoxPrimary } from '@wiseed/wikit';
	import { attrValue } from '@wiseed/wikit';
	import { consentVendorsStore } from '@app/stores/consent';
	import { onMount } from 'svelte';
	import { enableVendor, getVendorId, getVendorName } from '@app/utils/didomi';
	import { t } from 'svelte-i18n';

	export let operation: OperationModel;

	let isOpen = false;
	let isDidomiReady = false;

	const getConsentWallHTML = (vendorId) => {
		let vendorName = getVendorName(vendorId);

		return `<div class="consent-wall flex flex-col bg-grey-dark opacity-70 items-center justify-center absolute w-full h-full top-0 left-0 space-y-4 z-10"><div class="text-base text-center text-white w-3/4">${$t(
			'consent.videoProviderMessage',
			{ values: { name: vendorName } }
		)}</div> <button type="button" class="bg-white text-secondary px-4 py-3 rounded-lg font-semibold flex-shrink-0 inline-flex items-center btn">  <span class="label inline-block default">${$t(
			'consent.watchVideoBtnLabel'
		)}</span>  </button></div>`;
	};

	const setCTAListener = (ctn, i: HTMLIFrameElement, vendorId) => {
		let CTA = ctn.querySelector('.btn');
		CTA.addEventListener('click', () => {
			ctn.removeChild(ctn.querySelector('.consent-wall'));
			i.src = i.dataset.src;
			enableVendor(vendorId);
		});
	};

	onMount(() => {
		window.didomiOnReady = window.didomiOnReady || [];
		window.didomiOnReady.push(function (Didomi) {
			isDidomiReady = true;
		});
	});

	$: if ($consentVendorsStore !== {} && isDidomiReady) {
		let iframeArray = document.querySelectorAll('.project-description iframe');
		iframeArray.forEach((i: HTMLIFrameElement) => {
			if (i.dataset.src) {
				let vendorId = getVendorId(i.dataset.src as string);
				let isConsent;
				if ($consentVendorsStore !== {} && $consentVendorsStore[vendorId]) {
					isConsent = vendorId && $consentVendorsStore[vendorId].consent;
				}
				if (!isConsent) {
					let parent = i.parentElement;
					parent.insertAdjacentHTML('afterbegin', getConsentWallHTML(vendorId));
					setCTAListener(parent, i, vendorId);
				} else {
					i.src = i.dataset.src;
				}
			}
		});
	}
</script>

<div class="relative">
	{#if operation.projectDescriptionTitle}
		<h2 class="pt-4">{operation.projectDescriptionTitle}</h2>
	{/if}
	<div
		class:relative={!isOpen}
		class:blur-bottom={!isOpen}
		class={attrValue([
			'overflow-y-hidden border-b border-grey-light project-description',
			isOpen ? 'project-description__open' : 'project-description__close'
		])}
	>
		<p class="list-disc">{@html operation.projectDescription}</p>
	</div>
	<ButtonBoxPrimary
		props={{
			roundedFull: true,
			iconLeft: 'arrow-down',
			classNames: attrValue([
				'absolute top-full left-1/2 transform -translate-y-1/2 -translate-x-1/2',
				isOpen ? 'rotate-180' : ''
			])
		}}
		on:click={() => {
			isOpen = !isOpen;
		}}
	/>
</div>

<style lang="postcss">
	.project-description {
		min-height: 600px;
		transition-property: max-height;
		transition-duration: 2s;
		transition-timing-function: linear;
	}

	.project-description__open {
		max-height: 9999px;
		@apply pb-5;
	}

	.project-description__close {
		max-height: 600px;
	}

	.project-description__close.blur-bottom {
		&:before {
			content: '';
			@apply absolute w-full bottom-0 h-[150px];
			background: rgb(255, 255, 255);
			background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1) 50%);
		}
	}
</style>
